import { gql } from '@apollo/client';

export const FETCH_PERCH_CONSENT = gql`
  query Flex_FetchPerchConsent($signupContractTemplateId: Int!) {
    signupContractTemplateContractVersions(
      contractTypes: [consent]
      signupContractTemplateId: $signupContractTemplateId
    ) {
      id
      displayName
      internalName
      contractType
      notes
      fileUrl
    }
  }
`;
